var pseudo = { exports: {} };
export {
  pseudo as __module
};
//# sourceMappingURL=pseudo.js.map
